import { Card, CardContent, CardHeader } from "@design-system/Card";
import { Skeleton } from "@design-system/Skeleton";

 export const AccountManagementPageSubscriptionSkeleton  = () => {
    return (
      <div className="flex flex-col" data-testid="accountManagement-subscriptionSkeleton">
        <Skeleton className="h-8 w-32 mb-6" data-testid="accountManagement-subscriptionSkeleton-title" />
        <Card data-testid="accountManagement-subscriptionSkeleton-card">
          <CardHeader>
            <div className="flex items-center justify-between">
              <Skeleton className="h-7 w-32" />
            </div>
          </CardHeader>
          <CardContent data-testid="accountManagement-subscriptionSkeleton-content">
            <div className="flex flex-col gap-4">
              <div className="flex flex-wrap gap-4">
                {[...Array(4)].map((_, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <Skeleton className="size-16 rounded-md" />
                  </div>
                ))}
              </div>        
            </div>
          </CardContent>
        </Card>
      </div>
    );
  };
